import sum from "lodash/sum";

export const diffFatScoreHdAllocations = (saleLot: Partial<SaleLot>): number =>
  saleLot.quantity -
  sum(
    [
      saleLot.draftingAttributes?.fatScore1,
      saleLot.draftingAttributes?.fatScore2,
      saleLot.draftingAttributes?.fatScore3,
      saleLot.draftingAttributes?.fatScore4,
      saleLot.draftingAttributes?.fatScore5,
      saleLot.draftingAttributes?.fatScore6,
    ].filter(Boolean),
  );

export const diffMuscleScoreHdAllocations = (
  saleLot: Partial<SaleLot>,
): number =>
  saleLot.quantity -
  sum(
    [
      saleLot.draftingAttributes?.muscleScore1,
      saleLot.draftingAttributes?.muscleScore2,
      saleLot.draftingAttributes?.muscleScore3,
      saleLot.draftingAttributes?.muscleScore4,
      saleLot.draftingAttributes?.muscleScore5,
    ].filter(Boolean),
  );

export const diffHornHdAllocations = (saleLot: Partial<SaleLot>): number =>
  saleLot.quantity -
  sum(
    [
      saleLot.draftingAttributes?.hornPolled,
      saleLot.draftingAttributes?.hornHorned,
      saleLot.draftingAttributes?.hornDehorned,
      saleLot.draftingAttributes?.hornTipped,
      saleLot.draftingAttributes?.hornScurred,
    ].filter(Boolean),
  );

export const diffBreedHdAllocations = (saleLot: Partial<SaleLot>): number =>
  saleLot.quantity -
  sum(
    [
      saleLot.draftingAttributes?.advancedBreed1Hd,
      saleLot.draftingAttributes?.advancedBreed2Hd,
      saleLot.draftingAttributes?.advancedBreed3Hd,
    ].filter(Boolean),
  );

export const diffDentitionHdAllocations = (
  saleLot: Partial<SaleLot>,
): number =>
  saleLot.draftingAttributes?.isNotMouthed
    ? 0
    : saleLot.quantity -
      sum(
        [
          saleLot.draftingAttributes?.dentition0,
          saleLot.draftingAttributes?.dentition2,
          saleLot.draftingAttributes?.dentition4,
          saleLot.draftingAttributes?.dentition6,
          saleLot.draftingAttributes?.dentition8,
          saleLot.draftingAttributes?.dentitionBroken,
        ].filter(Boolean),
      );
